import baseService from "./baseService";

export default class CalculationsService extends baseService {

    calculateVolumeEstimate(weight, density) {
        return this.get(`api/calculations/volume/weight/${weight}/density/${density}`);
    }
    calculateWeightEstimate(volume, density) {
        return this.get(`api/calculations/weight/volume/${volume}/density/${density}`);
    }
}